/* eslint-disable no-unneeded-ternary */
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { UserLayoutRoute } from './../../routes';
import { ROLE_HOME, guardRedirect, resolveHome } from '../../utils/roleRoutes';
import Header from '../User/Header/Header';

const UserLayout = (props) => {
    const location = useLocation();
    const { pathname } = location;
    const userData = useSelector(state => state?.authReducer?.userinfo);

    // Both reads are synchronous localStorage lookups, so there is nothing to wait
    // for and no frame in which the guard has not yet decided.
    const storedRole = localStorage.getItem('aviagen_userRole');
    const hasToken = !!localStorage.getItem('aviagen_access_token');

    // The decision itself lives in roleRoutes so that it is testable and shared with
    // the login screen; see the loop-freedom note there.
    const redirect = guardRedirect(hasToken, userData?.sUserRole, storedRole, ROLE_HOME.user);
    if (redirect) {
        return <Navigate replace to={redirect} />;
    }

    // Past the guard, so the role resolved and it is this layout's.
    const home = resolveHome(userData?.sUserRole, storedRole);

    const authenticateRoute = () => {
        const routeIndex = UserLayoutRoute.findIndex(route => route.path === pathname.replace('/user', ''));
        if (pathname.replace('/user', '') !== '/' && routeIndex !== -1) {
            const Component = UserLayoutRoute[routeIndex].component;
            return Component;
        } else {
            // Unmatched path inside this layout: this role's own dashboard. Sending
            // it to '/' bounced off the login screen and back again.
            return <Navigate replace to={home} />;
        }
    };

    return (
        <>
            <Header {...props} />
            <Routes>
                {UserLayoutRoute?.map((route, index) => {
                    return (
                        <Route
                            key={index}
                            exact={route.exact}
                            path={route.path}
                            element={authenticateRoute()}
                        />
                    );
                })}
                <Route path="*" element={<Navigate replace to={home} />} />
            </Routes>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UserLayout);
